import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { IState } from 'models/reducers/i-state.interface';

import { ElementLoaderContext } from 'components/element-loader/ElementLoader';
import EmptyPageSection from 'components/emptyPageSection/EmptyPageSection';

import MarketNftCard from '../marketNftCard/MarketNftCard';
import './MarketList.scss';

const MarketList = () => {
  const { enableUi, disableUi } = useContext(ElementLoaderContext);
  const { marketItems: trades, loading, totalCount } = useSelector((state: IState) => state.market);

  useEffect(() => {
    if (loading) {
      disableUi();
    } else {
      enableUi();
    }
  }, [loading, enableUi, disableUi]);

  return (
    <div className="market-list__container tw-flex tw-h-full tw-flex-1 tw-flex-col">
      {!!trades?.length && (
        <>
          <p className="market-list__results-count">Results {totalCount}</p>
          <div className="market-list">
            {trades.map((trade) => (
              <MarketNftCard key={trade!.id} trade={trade} />
            ))}
          </div>
        </>
      )}
      {!trades?.length && !loading && <EmptyPageSection title="No trades" className="tw-m-auto" />}
    </div>
  );
};

export default MarketList;
